import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import {
	Button,
	Col,
	Form,
	FormFeedback,
	FormGroup,
	Input,
	Label,
	Row,
} from "reactstrap";
import authPermissionService from "../../../../services/AuthUserPermissionService";
import authUserService from "../../../../services/AuthUserService";
import authModuleService from "../../../../services/AuthModuleService";
import authActionService from "../../../../services/AuthActionService";
import * as Yup from "yup";
import { useFormik } from "formik";
import withRouter from "../../../../components/Common/withRouter";
import { useNavigate } from "react-router-dom";
import ActionModule from "./ActionModule";
import Loading from "components/Common/Loading";
import { FloppyDisk } from "@phosphor-icons/react";

const FormPerfilUsuario = (props) => {
	const params = props.router.params;
	const id = params?.id;

	const [data, setData] = useState([]);
	const [modules, setModules] = useState("");
	const [actionData, setActionData] = useState("");
	const [updateValues, setUpdateValues] = useState([]);
	const [moduleEdit, setModuleEdit] = useState("");
	const [isLoading, setIsLoading] = useState(false);

	document.title = "Senda | Perfil Usuário";

	const navigate = useNavigate();

	const validation = useFormik({
		enableReinitialize: true,
		initialValues: {
			name: data?.name || moduleEdit?.name || "",
		},
		validationSchema: Yup.object({
			name: Yup.string().required("Por favor, informe o nome do perfil!"),
		}),
		onSubmit: async (values) => {
			const updateValuesInt = updateValues.map((n) => {
				return parseInt(n, 10);
			});
			const sortUpdateValuesInt = updateValuesInt.sort((a, b) => a - b);
			const allValues = {
				name: values.name,
				action_ids: sortUpdateValuesInt,
			};

			if (id) {
				await authPermissionService.put(id, allValues);
			} else {
				await authPermissionService.post(allValues);
			}
			navigate("/perfil-usuarios");
		},
	});

	const getModuleEdit = async () => {
		if (id) {
			try {
				const response = await authPermissionService.getById(id);
				setModuleEdit(response);
			} catch (error) {
				console.log(error);
			}
		}
	};

	const getModules = async () => {
		try {
			const response = await authModuleService.get();
			setModules(response);
		} catch (error) {
			console.log(error);
		}
	};

	const getActions = async () => {
		if (id) {
			try {
				const response = await authUserService.getById(id);
				setData(response);
			} catch (error) {
				console.log(error);
			}
		}
	};

	const getAllActions = async () => {
		try {
			const response = await authActionService.get();
			setActionData(response);
		} catch (error) {
			console.log(error);
		}
	};

	const updateValuesActions = (ids) => {
		setUpdateValues(ids);
	};

	const getAll = async () => {
		setIsLoading(true);
		if (id) {
			await getActions();
		}
		await getModuleEdit();
		await getModules();
		await getAllActions();
		setIsLoading(false);
	};

	useEffect(() => {
		getAll();
	}, []);

	return (
		<Loading isLoading={isLoading}>
			<div className="page-content">
				<Breadcrumbs
					title="Perfil de Usuários"
					breadcrumbItem="Perfil de usuário"
					backLink="/perfil-usuarios"
				/>

				<div
					className="container-fluid"
					style={{
						backgroundColor: "white",
						padding: 20,
						borderRadius: 10,
						marginTop: 25,
					}}
				>
					<Form
						className="needs-validation"
						onSubmit={(e) => {
							e.preventDefault();
							validation.handleSubmit();
							return false;
						}}
					>
						<Row>
							<Col md="12">
								<FormGroup className="mb-3">
									<Label htmlFor="validationCustom01">
										Nome do perfil
									</Label>
									<Input
										maxLength={60}
										name="name"
										placeholder="Nome do perfil"
										type="text"
										className="form-control"
										id="validationCustom01"
										onChange={validation.handleChange}
										onBlur={validation.handleBlur}
										value={validation.values.name || ""}
										invalid={
											validation.touched.name &&
											validation.errors.name
												? true
												: false
										}
									/>
									{validation.touched.name &&
									validation.errors.name ? (
										<FormFeedback type="invalid">
											{validation.errors.name}
										</FormFeedback>
									) : null}
								</FormGroup>
							</Col>

							<div
								className="page-title-right"
								style={{
									display: "flex",
									justifyContent: "end",
								}}
							>
								<Button
									type="submit"
									style={{
										background: "none",
										padding: 10,
										cursor: "pointer",
										color: "black",
										marginLeft: 10,
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										gap: 2,
										width: 150,
									}}
								>
									<FloppyDisk size={16} /> Salvar
								</Button>
							</div>
						</Row>

						<div
							className="container-fluid"
							style={{ backgroundColor: "white" }}
						>
							{actionData && (data || !id) && modules && (
								<ActionModule
									modules={modules} // Todos os modulos cadastrados
									actions={actionData} // Todas as ações cadastradas
									actionItems={data} // Ações já configuradas no banco
									updateActions={updateValuesActions} //Atualiza lista de ações pelo checkbox
								/>
							)}
						</div>
					</Form>
				</div>
			</div>
		</Loading>
	);
};
FormPerfilUsuario.propTypes = {
	preGlobalFilteredRows: PropTypes.any,
};

export default withRouter(FormPerfilUsuario);
